import { ABOVE_PROP_USER_TYPE, corpUser, DEFAULT_CORP_INNCODE } from "utils/CommonConstants";
import { getUserHltId } from "utils/CommonFunctions";
import { getLoggedInUserDetails } from "utils/UserAnalyticsUtils";

export const payloadForBuzz = () => {
  const user = getLoggedInUserDetails();
  const lobbyType = user?.lobbyUserType?.toLowerCase();
  const originalLobbyType = user?.originalLobbyUserType?.toLowerCase();
  if (corpUser.includes(lobbyType) && (!originalLobbyType || corpUser.includes(originalLobbyType))) {
    return [];
  }
  return user.innCodes;
};

export const checkIfUserIsCorp = () => {
  const user = getLoggedInUserDetails();
  const lobbyType = user?.lobbyUserType?.toLowerCase();
  const originalLobbyType = user?.originalLobbyUserType?.toLowerCase();
  if (corpUser.includes(lobbyType) && (!originalLobbyType || corpUser.includes(originalLobbyType))) {
    return true;
  }
  return false;
};

export const resolveInncodesByUserType = (inncode: any) => {
  const isCorp = checkIfUserIsCorp();
  const user = getLoggedInUserDetails();
  if (isCorp) return DEFAULT_CORP_INNCODE;
  const userLobbyType = user?.lobbyUserType?.toLowerCase();
  if (!isCorp && userLobbyType !== ABOVE_PROP_USER_TYPE) {
    return inncode;
  } else {
    return user.innCodes;
  }
};

export const hasBoostBuzz = (ReleaseHighlights: any, userInncodes: any) => {
  if (checkIfUserIsCorp() && ReleaseHighlights?.[getUserHltId()]?.allCards?.length) return true;
  const values = Array.isArray(userInncodes) ? userInncodes : [userInncodes];
  return ReleaseHighlights?.[getUserHltId()]?.allCards?.some((card: any) =>
    values.some((val: any) => card.targets.includes(val))
  );
};
